import { render, staticRenderFns } from "./LiveRank.vue?vue&type=template&id=0261fd5e&scoped=true"
import script from "./LiveRank.vue?vue&type=script&lang=js"
export * from "./LiveRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0261fd5e",
  null
  
)

export default component.exports